import React, { useMemo, useState, useEffect } from 'react';
import { Tree } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const TimelineBar = ({ CreatedOn }) => {
  const [expandedKeys, setExpandedKeys] = useState([]);

  const timelineData = useMemo(() => {
    if (!CreatedOn) return [];

    const start = dayjs(CreatedOn);
    const end = dayjs();
    const years = [];

    for (let y = start.year(); y <= end.year(); y++) {
      const isStartYear = y === start.year();
      const isEndYear = y === end.year();
      const months = [];

      const monthStart = isStartYear ? start.month() : 0;
      const monthEnd = isEndYear ? end.month() : 11;

      for (let m = monthStart; m <= monthEnd; m++) {
        const days = [];

        const dayStart = (isStartYear && m === start.month()) ? start.date() : 1;
        const dayEnd = (isEndYear && m === end.month()) ? end.date() : dayjs(`${y}-${m + 1}`, 'YYYY-M').daysInMonth();

        for (let d = dayStart; d <= dayEnd; d++) {
          days.push({
            title: ` ${d}`,
            key: `${y}-${m + 1}-${d}`,
            isLeaf: true,
          });
        }

        months.push({
          title: dayjs().month(m).format('MMM'),
          key: `${y}-${m + 1}`,
          children: days,
        });
      }

      years.push({
        title: `${y}`,
        key: `${y}`,
        children: months,
      });
    }

    return years;
  }, [CreatedOn]);

  useEffect(() => {
    const now = dayjs();
    const defaultExpandedKeys = [
      `${now.year()}`,
      `${now.year()}-${now.month() + 1}`
    ];
    setExpandedKeys(defaultExpandedKeys);
  }, []);

  return (
    <div
      style={{
        width: 250,
        overflowY: 'auto',
        height: '100vh',
        borderLeft: '1px solid #eee',
        padding: 12,
        position: 'sticky',
        top: 0,
        backgroundColor: '#fafafa',
      }}
    >
      <h4 style={{ textAlign: 'left' }}>Activity Timeline</h4>
      <Tree
        showLine
        switcherIcon={<DownOutlined />}
        treeData={timelineData}
        expandedKeys={expandedKeys}
        onExpand={(keys) => setExpandedKeys(keys)}
      />
    </div>
  );
};

export default TimelineBar;
